export default {
  REPLACE_MY_PROFILE: 'REPLACE_MY_PROFILE',
  RESET_MY_PROFILE_STATE: 'RESET_MY_PROFILE_STATE',
  SET_MY_PROFILE: 'SET_MY_PROFILE',
  SET_EDITING_MY_PROFILE: 'SET_EDITING_MY_PROFILE',
  SET_MY_PROFILE_IS_LOADING: 'SET_MY_PROFILE_IS_LOADING',
};
